export const FROM_PREFIX = 'userGuide';

// ROBLOX
export const DEFAULT_MOBILE_GAMEID = 'u080032403b0f3d7ce099ec68649d222a';
// pc版 Fortnite
export const DEFAULT_PC_GAMEID = 'efac98152ddaf5d5d08d6286e2626e83c';
// Tencent
export const DEFAULT_COMPANYID = '3cae090b-ed2d-95f8-79a9-e32ca480258f';

export const parseUserGuideStep = (from: string): number => {
  if (typeof from !== 'string') return 0;
  const numChar = from.replace(`${FROM_PREFIX}_`, '');
  const num = Number.parseInt(numChar, 10);
  return Number.isNaN(num) ? 0 : num;
};

export const generateURLByUserGuideStep = (url: string, step: number): string => {
  if (typeof url !== 'string') return '';
  if (typeof step !== 'number') return url;
  if (step === 0) return url;
  const searchIdx = url.indexOf('?');
  const pathname = searchIdx === -1 ? url : url.substring(0, searchIdx);
  const initialSearchParamsStr = searchIdx === -1 ? '' : url.substring(searchIdx + 1);
  const searchParams = new URLSearchParams(initialSearchParamsStr);
  searchParams.set('from', `${FROM_PREFIX}_${step}`);
  return `${pathname}?${searchParams.toString()}`;
};


